import { render, staticRenderFns } from "./manage.vue?vue&type=template&id=33e5c2f0"
import script from "./manage.vue?vue&type=script&lang=ts"
export * from "./manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33e5c2f0')) {
      api.createRecord('33e5c2f0', component.options)
    } else {
      api.reload('33e5c2f0', component.options)
    }
    module.hot.accept("./manage.vue?vue&type=template&id=33e5c2f0", function () {
      api.rerender('33e5c2f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/products-fields-value/manage.vue"
export default component.exports